import { configureStore, Store } from "@reduxjs/toolkit"
import { reducers as sharedReducers } from "@hydrologiq/shared/state/store"

const store: Store = configureStore({
  reducer: {
    ...sharedReducers,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [],
        ignoredPaths: [],
      },
    }),
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export default store
